import { ListFilterCustomSelect } from "../../components/ListFilterCustomSelect";
import { DatePicker } from "../../components/ui/DatePicker";
import { FLOW_TEXT_INPUT_BASE } from "../../styles/twDesignPrimitives";
import {
  AutomationFilterOption,
  NOTIFICATION_CHANNEL_FILTERS,
  NOTIFICATION_STATUS_FILTERS,
  NotificationChannel,
  NotificationStatus,
} from "./notificationsListQuery";

type Props = {
  recipientTerm: string;
  channelFilter: NotificationChannel;
  statusFilter: NotificationStatus;
  automationFilter: string;
  fromDate: string;
  toDate: string;
  automationOptions: AutomationFilterOption[];
  onRecipientChange: (value: string) => void;
  onChannelChange: (value: NotificationChannel) => void;
  onStatusChange: (value: NotificationStatus) => void;
  onAutomationChange: (value: string) => void;
  onFromDateChange: (value: string) => void;
  onToDateChange: (value: string) => void;
};

export function NotificationsListFilters({
  recipientTerm,
  channelFilter,
  statusFilter,
  automationFilter,
  fromDate,
  toDate,
  automationOptions,
  onRecipientChange,
  onChannelChange,
  onStatusChange,
  onAutomationChange,
  onFromDateChange,
  onToDateChange,
}: Props) {
  return (
    <div className="mb-4 flex w-full flex-col gap-3 md:flex-row md:flex-wrap md:items-end">
      <label className="flex min-w-0 flex-1 flex-col gap-1 text-left text-xs font-medium text-slate-600 md:max-w-md">
        Destinatário
        <input
          className={`${FLOW_TEXT_INPUT_BASE} !font-[inherit]`}
          value={recipientTerm}
          onChange={(event) => onRecipientChange(event.target.value)}
          placeholder="Buscar por e-mail ou telefone..."
        />
      </label>

      <ListFilterCustomSelect
        label="Canal"
        value={channelFilter}
        options={NOTIFICATION_CHANNEL_FILTERS}
        onChange={(value) => onChannelChange(value as NotificationChannel)}
      />

      <ListFilterCustomSelect
        label="Status"
        value={statusFilter}
        options={NOTIFICATION_STATUS_FILTERS}
        onChange={(value) => onStatusChange(value as NotificationStatus)}
      />

      <ListFilterCustomSelect
        label="Automação"
        value={automationFilter}
        options={automationOptions}
        onChange={onAutomationChange}
        className="md:min-w-[280px]"
      />

      <DatePicker label="De" value={fromDate} onChange={onFromDateChange} />
      <DatePicker label="Até" value={toDate} onChange={onToDateChange} />
    </div>
  );
}
